import moment from "moment";
import { useCallback, useEffect, useState } from "react";
import APIS from "../../constant/Endpoint";
import DataTable from "../Reusable/DataTable";
import NACell from "../Reusable/DataTable/NACell";
import Modal from "../Reusable/Modal";
import TableActionButton from "../Reusable/TableActionButton";
import ChangeStatus from "./ChangeStatus";
//@ts-ignore
import { AccessControl } from "@careinfo/permission-required";
import { tw } from "@careinfo/tailwind";
import { useSessionStorage } from "@uidotdev/usehooks";
import { useForm } from "react-hook-form";
import { hasValues } from "../../utils/hasValues";
import Card from "../Reusable/Card";
import TicketFilter from "./TicketFilter";
import Reply from "./Reply";
export interface IFilter {
  // user: string | null;
  priority: string | null;
  created__range: string | null;
  queue: string | null;
  status: string | null;
}
const TicketList = (props: any) => {
  const [openStatusChangePopup, setOpenStatusChangePopup] = useState(false);
  const [openReplyPopup, setOpenReplyPopup] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);

  const [localState, handleSetState] = useSessionStorage<IFilter>(
    "ticket-filter",
    {
      priority: null,
      created__range: null,
      queue: null,
      status: null,
    }
  );
  const {
    register,
    setValue,
    getValues,
    watch,
    setError,
    reset,
    clearErrors,
    control,
    formState: { errors },
  } = useForm<IFilter>({
    defaultValues: async () => {
      return {
        priority: localState?.priority ?? null,
        created__range: localState?.created__range ?? null,
        queue: localState?.queue ?? null,
        status: localState?.status ?? null,
      };
    },
  });
  const [isFilterVisible, setFilterVisiable] = useState(hasValues(localState));

  const handleRowAction = (row: any) => {
    setSelectedRow(row);
    setOpenStatusChangePopup(true);
  };

  
    const defaultColumns: any = [
  {
    id: "vendor",
    header: "Vendor",
    accessorKey: "title",
    cell: NACell,
  },
  {
    id: "subject",
    header: "Subject",
    accessorKey: "queue.name",
    cell: NACell,
  },
  {
    id: "description",
    header: "Description",
    accessorKey: "description",
    cell: NACell,
  },
  {
    id: "reply",
    header: "Reply",
    accessorKey: "resolution",
    cell: ({ row, getValue }: any) => (
      <button
        onClick={(e) => {
          e.stopPropagation(); // Stops the row-click from opening the Status modal
          setSelectedRow(row);
          setOpenReplyPopup(!openReplyPopup);
        }}
        className={tw`foucus:outline-none hover:underline text-blue-500`}
      >
        {getValue() ?? "N/A"}
      </button>
    ),
  },
  {
    id: "priority",
    header: "Priority",
    accessorKey: "priority",
    cell: NACell,
  },
  {
    id: "created",
    header: "Created",
    accessorKey: "created",
    cell: ({ row, getValue }: any) => {
      return (
        <p>
          {getValue()
            ? moment(getValue()).format("YY-MM-DD HH:mm:ss")
            : "N/A"}
        </p>
      );
    },
  },
  {
    id: "status",
    header: "Status",
    accessorKey: "status.name",
    cell: NACell,
  } 
];
  const filterParams = watch();
  useEffect(() => {
    handleSetState({
      ...localState,
      ...filterParams,
    });
  }, [filterParams]); //eslint-disable-line

  const params = useCallback(() => {
    const newValue = {};
    for (const [key, value] of Object.entries(filterParams)) {
      if (value) {
        if (Array.isArray(value)) {
          newValue[key] = value.map((v) => v.value).join(",");
        } else if (typeof value === "object") {
          newValue[key] = value.id;
        } else if (!value) {
          newValue[key] = null;
        } else {
          newValue[key] = value;
        }
      }
    }
    return newValue;
  }, [filterParams]);

  const handleFilterReset = () => {
    reset({
      priority: null,
      created__range: null,
      queue: null,
      status: null,
    });
  };

  return (
    <>
      <AccessControl
        children={
          <Card
            title="Filters"
            onClick={() => setFilterVisiable(!isFilterVisible)}
          >
            <TicketFilter
              register={register}
              getValues={getValues}
              watch={watch}
              errors={errors}
              clearErrors={clearErrors}
              setValue={setValue}
              reset={handleFilterReset}
              control={control}
              isFilterVisible={isFilterVisible}
            />
          </Card>
        }
        allowedPermissions={["can_perform_ticket_action"]}
      />
      <DataTable
        url={APIS.TICKET}
        queryKey={"ticket"}
        columns={defaultColumns}
        tableName={"Ticket"}
        isUpload={false}
        params={params()}
        onRowClick={(row:any)=> handleRowAction(row)}
      />

      <Modal
        isOpen={openReplyPopup}
        setIsOpen={setOpenReplyPopup}
        title={"Reply"}
      >
        <Reply selectedRow={selectedRow} canInput={true} />
      </Modal>

      <Modal
        isOpen={openStatusChangePopup}
        setIsOpen={setOpenStatusChangePopup}
        title={"Change Status"}
        children={
          <>
            <ChangeStatus
              selectedId={selectedRow?.original?.id}
              setOpenStatusChangePopup={setOpenStatusChangePopup}
            />
          </>
        }
      />
    </>
  );
};

export default TicketList;
